import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Fire } from "@phosphor-icons/react";

const RISE_IN = { opacity: 0, y: 18 };
const RISE_VISIBLE = { opacity: 1, y: 0 };
const RISE_OUT = { opacity: 0, y: -18 };
const RISE_TRANSITION = { duration: 0.45, ease: [0.22, 1, 0.36, 1] };

// Auto-rotating "Trending Now" strip showing the latest posts.
export default function TrendingStrip({ posts }) {
    const [idx, setIdx] = useState(0);

    useEffect(() => {
        if (posts.length < 2) return;
        const t = setInterval(() => setIdx(i => (i + 1) % posts.length), 4000);
        return () => clearInterval(t);
    }, [posts.length]);

    if (!posts.length) return null;
    const post = posts[idx];

    return (
        <div className="border-b border-zinc-800 bg-[#0D0D0D]" data-testid="trending-strip">
            <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-14 flex items-center gap-5 overflow-hidden">
                <span className="flex items-center gap-2 font-mono text-[10px] font-bold uppercase tracking-[0.3em] text-[#FFD000] shrink-0">
                    <Fire size={14} weight="fill" /> Trending
                </span>
                <span className="w-px h-5 bg-zinc-800 shrink-0" />
                <div className="relative flex-1 h-full overflow-hidden">
                    <AnimatePresence mode="popLayout">
                        <motion.div
                            key={post.id}
                            className="absolute inset-0 flex items-center"
                            initial={RISE_IN}
                            animate={RISE_VISIBLE}
                            exit={RISE_OUT}
                            transition={RISE_TRANSITION}
                        >
                            <Link
                                to={`/post/${post.slug}`}
                                data-testid="trending-strip-link"
                                className="truncate text-sm font-bold uppercase tracking-wider text-zinc-200 hover:text-[#FFD000] transition-colors"
                            >
                                {post.title}
                            </Link>
                        </motion.div>
                    </AnimatePresence>
                </div>
                <span className="font-mono text-[10px] tracking-[0.25em] text-zinc-500 shrink-0" data-testid="trending-strip-counter">
                    {String(idx + 1).padStart(2, "0")} / {String(posts.length).padStart(2, "0")}
                </span>
            </div>
        </div>
    );
}
